//move it to some config maybe
export const DefineColors = {
    time: {
        free: "#2180f7",
        scheduled: "#fec864",
        technical: "#969696"
    },
    operations: {
        awaiting: "#2180f7",
        ended: "#4eac6f",
        inProgress: "#fec864",
        deleted: "#e25b61",
        inHolding: "#8353b7",
    },
    patients: {
        scheduled: "#2180f7",
        deceased: "#e25b61",
        missing: "#969696",
    },
    occupancy: [
        {
            valueFrom: 0,
            valueTo: 40,
            color: "#4eac6f"
        },{
            valueFrom: 40,
            valueTo: 85,
            color: "#fec864"
        },{
            valueFrom: 85,
            valueTo: 101,
            color: "#e25b61"
        }
    ]
}

export const WorkloadTypes = {
    patients: "Patients",
    operations: "Operations",
    occupancy: "Occupancy",
    time: "Time"
}

export const ShowOptionTypes = {
    all: "All",
    am: "AM",
    pm: "PM",
    tw: "TW",
    allDay: "AD",
}

export const SortOptionTypes = {
    freeSlots: "Free slots",
    option1: "option 1",
    option2: "option 2",
    option3: "option 3",
}

export const TableDataShowTypes = {
    table: "Table",
    chart: "Chart"
}

export const PrintDataSourced = {
    patient: "Patient",
    list: "List",
}

export const PrintPageOrientation = {
    horizontal: "Horizontal",
    vertical: "Vertical",
}

export const PrintOutputType = {
    pdf: "PDF",
    html: "HTML",
}